import { hasAnalyzableFiles } from '../documentReader';

export function shouldUseServerOwnedAttachmentTurn(params: {
  isMigrated: boolean;
  hasAccountId: boolean;
  attachments?: File[];
}): boolean {
  if (!params.isMigrated || !params.hasAccountId) return false;
  if (!params.attachments || params.attachments.length === 0) return false;
  return hasAnalyzableFiles(params.attachments);
}

export function buildPrest0nTurnDispatchOptions(params: {
  serverOwnedAttachmentTurn: boolean;
  preAnalyzedDocumentContent?: string;
}): { documentContent?: string; responseMode: 'async' | 'auto' } {
  if (params.serverOwnedAttachmentTurn) {
    return {
      documentContent: undefined,
      responseMode: 'async',
    };
  }

  return {
    documentContent: params.preAnalyzedDocumentContent,
    responseMode: 'auto',
  };
}
